<!-- Hidden file input - always available -->
<input
  #fileInput
  type="file"
  multiple
  style="display:none;"
  (change)="fileInputChangedEvent($event)"
  [accept]="acceptString()"/>

@if (headline()) {
  <div class="basis-full flex flex-row items-center mb-3 rounded-t-md">
    <div class="grow text-[1.125rem] font-medium">
      {{headline()}} <!--({{totalElements()}}) -->
    </div>
    @if (uploadProgress(); as progress) {
      <div class="text-sm text-gray-500 mr-2">{{progress.current}}/{{progress.total}} {{uploadedText}}</div>
    }
    @if (rolesService.hasRole('framework_files_manage')) {
      <nx-default-button
        [style]="'dark'"
        (click)="fileInput.click()"
        [tooltip]="uploadText"
        [icon]="'icon-plus'">
      </nx-default-button>
    }
  </div>
}
@if (files().length === 0) {
  <div 
    class="text-base border border-dashed rounded-md min-h-[74px] flex flex-col items-center justify-center transition-colors cursor-pointer"
    [class.border-gray-300]="!isDragging() && !dropError()"
    [class.text-gray-400]="!isDragging() && !dropError()"
    [class.border-blue-400]="isDragging()"
    [class.bg-blue-50]="isDragging()"
    [class.text-blue-500]="isDragging()"
    [class.border-red-400]="dropError()"
    [class.bg-red-50]="dropError()"
    [class.text-red-500]="dropError()"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
    (click)="rolesService.hasRole('framework_files_manage') && fileInput.click()">
    @if (dropError(); as error) {
      <span>{{error}}</span>
    } @else if (isDragging()) {
      {{dropHereText}}
    } @else {
      @if (rolesService.hasRole('framework_files_manage')) {
        <i class="text-[32px]" [ngClass]="'icon-document-upload'"></i>
      }
      <span class="mt-[-6px] mb-[10px]">{{emptyMessage()}}</span>
    }
  </div>
} @else {
  <div 
    class="relative rounded-md transition-colors"
    [class.ring-2]="isDragging() || dropError()"
    [class.ring-blue-400]="isDragging()"
    [class.bg-blue-50]="isDragging()"
    [class.ring-red-400]="dropError()"
    [class.bg-red-50]="dropError()"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)">
    
    @if (dropError(); as error) {
      <div class="absolute inset-0 flex items-center justify-center bg-red-50/80 rounded-md z-20">
        <span class="text-red-500 text-sm font-medium">{{error}}</span>
      </div>
    }
    
    @for (file of files(); track file.id) {
      <app-file-list-item-v2
        (refetch)="onFileDeleted()"
        [file]="file"
        [ownerId]="ownerId()">
      </app-file-list-item-v2>
    }
  </div>
  
  @if (showPagination()) {
    <div class="flex justify-end items-center mt-2">
        <nx-default-button
        [style]="'dark'"
        class="ml-2"
        (click)="previousPage()"
        [disabled]="!hasPreviousPage()"
        [icon]="'icon-previous'">
      </nx-default-button>
      <nx-default-button
        [style]="'dark'"
        class="ml-2"
        (click)="nextPage()"
        [disabled]="!hasNextPage()"
        [icon]="'icon-next'">
      </nx-default-button>
    </div>
  }
}


